import { ChatPanel } from "../components/ChatPanel";
import type { Profile } from "../api/types";

/** The chat as its own page. The same panel also sits in the database view
 *  (vertical split) — one implementation, one conversation, two places. */
export function ChatView({ profile }: { profile: Profile }) {
  return <ChatPanel profile={profile} />;
}
